'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _VerticalAlignTopOutlined = _interopRequireDefault(require('./lib/icons/VerticalAlignTopOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _VerticalAlignTopOutlined;
  exports.default = _default;
  module.exports = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@ant-design/icons/VerticalAlignTopOutlined.js
// module id = 427
// module chunks = 0